import React, { Component } from 'react';
import {Table, Checkbox, Icon, Label} from 'semantic-ui-react'
import AdminApi from '../../utils/AdminApi'
import UserApi from '../../utils/UserApi'

class UserRow extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      open: false,
      target_reads: '',
      deadline: '',
      id: '',
      active: props.data.active,
      confirmed: props.data.confirmed,
      admin: props.data.admin
    }

    this.handleOpen = this.handleOpen.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleActive = this.handleActive.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleMakeAdmin = this.handleMakeAdmin.bind(this)
  }  
  
  toggleRow(e) {
    console.log('toggleRow');
    this.setState({open: !this.state.open});
  }
  /*onClick={this.toggleRow.bind(this)} className={classes}>   <RoundRowExpanded open={this.state.open}/>*/
    
  handleChange(event, {name, value}){
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  }

  handleOpen(){
    this.setState({
      open: !this.state.open,
      target_reads: this.props.data.target_reads,
      deadline: this.props.data.deadline,
      id: this.props.data.id
    })
    
  }
  
  handleSubmit(event){
    AdminApi.editRound(this.state)
    .then(response => {
      window.location.reload()
    })

    this.handleOpen()
  }

  handleActive(){
    if(this.state.active){
      AdminApi.deactivateUser(this.props.data.id)
    } else {
      AdminApi.activateUser(this.props.data.id)
    }
    this.setState({
      active: !this.state.active
    })
  }

  handleConfirm(){
    AdminApi.confirmUser(this.props.data.id)
    .then(response => {
      this.setState({
        confirmed:true
      })
    })

  }

  handleMakeAdmin(){
    UserApi.currentUser()
    .then(response => {
      if(response.data.id !== this.props.data.id){
        AdminApi.makeAdmin(this.props.data.id, !this.state.admin)
        .then(response => {
          this.setState({
            admin:!this.state.admin
          })
        })
      }
    })
    
  }

  render(){
    
    let short_data = {
        name: this.props.data.name,
        email: this.props.data.email,
        last_graded: this.props.data.last_graded,
        admin: this.state.admin,
      }
    
    let row = Object.values(short_data).map((item, idx) => 
      <Table.Cell disabled={!this.state.confirmed} key={item+"-"+idx}>{item === null?"None":item.toString()}</Table.Cell>
    )
    row.unshift(
      <Table.Cell disabled={!this.state.confirmed} key={'Active'}><Checkbox slider checked={this.state.active} onClick={this.handleActive} /></Table.Cell>
    )
    row.push(
      <Table.Cell key={'Make Admin'}>
        <Icon link name='key' onClick={this.handleMakeAdmin}/>
        {this.state.confirmed?null:<Label as='a' ribbon='right' onClick={this.handleConfirm}>Confirm User</Label>}
      </Table.Cell>
    )

    return(
      <Table.Row positive={this.state.admin} children={row}></Table.Row>
    )
  }
  
};

export default UserRow



       


// WEBPACK FOOTER //
// ./src/components/admin/users_table/UserRow.js